'use strict';

/* eslint no-undef: "off" */
/**
 * pp shop content
 */
define('commonBehaviours',['busEvent', 'loading', 'appStorage'], function (busEvent, Loading, appStorage) {
  return {
    template: '\n      <div>\n        <div class="in-info">\n          <modal\n            name="msg"\n            width="75%"\n            height="auto"\n            :transition="\'overlay-fade\'"\n            :delay="10"\n          >\n            <div class="in-modal">\n              <p v-html="modalMsg"></p>\n            </div>\n          </modal>\n        </div>\n        <div class="in-info in-modal-box xp-ui">\n          <modal\n            name="linkModal"\n            width="75%"\n            height="auto"\n            :delay="10"\n            :transition="\'overlay-fade\'"\n            @closed="hideModal"\n          >\n            <div class="in-modal">\n              <p v-text="modalMsg"></p>\n              <div class="in-btn-group in-modal-share-btn">\n                <a v-for="link in links" :href="link.href"  :target="link.target || \'\'" v-text="link.title" ></a>\n              </div>\n            </div>\n          </modal>\n        </div>\n\n        <modal\n          name="information"\n          :transition="\'pop-out\'"\n          :adaptive="true"\n          width="100%"\n          height="auto"\n          :pivotY=1\n          @closed="hideModal"\n        >\n          <div class="in-container" v-if="modalMsg">\n            <div class="confirm-container">\n              <p class="msg" v-text="modalMsg"></p>\n            </div>\n            <div class="in-btn">\n              <button\n                @click.prevent="hideModal"\n                v-text="i18n.cancel"\n                class="confirm-cancel"\n              ></button>\n              <button\n                v-text="i18n.confirm"\n                @click.prevent="confirmAction"\n              ></button>\n            </div>\n          </div>\n        </modal>\n        <div class="in-dialog-box">\n          <modal\n            name="dialog"\n            width="85%"\n            height="auto"\n            :transition="\'overlay-fade\'"\n            :clickToClose="false"\n            :delay="10">\n              <div class="xp-dialog-container in-modal">\n                <p class="title" v-text="dialog_title"></p>\n                <p class="message-text" v-text="dialog_message"></p>\n                <div class="in-btn-group">\n                  <button @click="dialogAction" v-text="dialog_btn_txt"></button>\n                </div>\n              </div>\n          </modal>\n        </div>\n\n\n        <Loading></Loading>\n      </div>\n    ',
    data: function data() {
      return {
        i18n: {
          cancel: 'Cancel',
          confirm: 'Confirm',
          defaultSuccess: 'Operation Successful!',
          defaultHint: 'Something went wrong, please try again later!',
          defaultError: 'Operation Failed!',
          defaultLogin: "You've not login yet, please login!",
          login: 'Login'
        },
        modalMsg: '',
        iconSuccess: '', // success/error/hint
        confirmBar: false,
        linkBar: false,
        links: [],
        hideEventQueue: [],
        loadingNested: 0,
        token: '',
        dialog_title: 'Notice',
        dialog_message: '',
        dialog_btn_txt: 'OK',
        dialog_action: null
      };
    },
    created: function created() {
      busEvent.$on('modalSuccess', this.showSuccessModal.bind(this));
      busEvent.$on('modalHint', this.showHintModal.bind(this));
      busEvent.$on('modalError', this.showErrorModal.bind(this));
      busEvent.$on('confirmModal', this.confirmModal.bind(this));
      busEvent.$on('beginLoading', this.beginLoading.bind(this));
      busEvent.$on('endLoading', this.endLoading.bind(this));
      busEvent.$on('showLoginModal', this.showLoginModal.bind(this));
      busEvent.$on('showLinkMessage', this.showLinkMessage.bind(this));
      busEvent.$on('produceHideEvent', this.hideEventProducer.bind(this));
      busEvent.$on('getCookie', this.getCookie.bind(this));
      busEvent.$on('setToken', this.setToken.bind(this));
      busEvent.$on('dialogModal', this.dialogModal.bind(this));
    },

    components: {
      Loading: Loading
    },
    mounted: function mounted() {},

    methods: {
      beginLoading: function beginLoading() {
        if (this.loadingNested === 0) {
          busEvent.$emit('loadingShowEvent');
        }
        this.loadingNested++;
      },
      hideEventProducer: function hideEventProducer(ev) {
        this.hideEventQueue.push(ev);
      },
      consumHideEvent: function consumHideEvent() {
        while (ev = this.hideEventQueue.pop()) {
          switch (ev.action) {
            case 'reload':
              this.beginLoading();
              location.reload();
              break;
            default:
              break;
          }
        }
      },
      endLoading: function endLoading() {
        this.loadingNested--;
        if (this.loadingNested <= 0) {
          var that = this;
          setTimeout(function () {
            busEvent.$emit('loadingHideEvent');
            that.loadingNested = 0;
          }, 50);
        }
      },
      showSuccessModal: function showSuccessModal(message) {
        this.iconSuccess = 'success';
        this.showModal(message || this.i18n.defaultSuccess);
      },
      showErrorModal: function showErrorModal(message) {
        this.iconSuccess = 'error';
        this.showModal(message || this.i18n.defaultError);
      },
      showHintModal: function showHintModal(message) {
        this.iconSuccess = 'hint';
        this.showModal(message || this.i18n.defaultHint);
      },
      confirmModal: function confirmModal(message) {
        this.iconSuccess = 'hint';
        this.confirmBar = true;
        this.linkBar = false;
        this.modalMsg = message;
        this.$modal.show('information');
      },
      dialogModal: function dialogModal(title, message, btnTxt, func) {
        if (title) this.dialog_title = title;
        this.dialog_message = message;
        if (btnTxt) this.dialog_btn_txt = btnTxt;
        if (func) this.dialog_action = func;
        this.$modal.show('dialog');
      },
      dialogAction: function dialogAction() {
        if (this.dialog_action) {
          this.dialog_action();
        }
        this.$modal.hide('dialog');
      },
      showModal: function showModal(message) {
        var _this = this;

        this.modalMsg = message;
        this.confirmBar = false;
        this.linkBar = false;
        this.$modal.show('msg');
        setTimeout(function () {
          _this.hideModal();
        }, 1500);
      },
      showLinkMessage: function showLinkMessage(message, links) {
        this.iconSuccess = 'hint';
        this.confirmBar = false;
        this.linkBar = true;
        this.modalMsg = message;
        this.links = links;
        this.$modal.show('linkModal');
      },
      showLoginModal: function showLoginModal() {
        this.showLinkMessage(this.i18n.defaultLogin, [{ href: '/customer/account/login/uenc/' + window.btoa(location.href), title: this.i18n.login }]);
      },
      confirmAction: function confirmAction() {
        this.hideModal();
        busEvent.$emit('modalConfirmed');
      },

      /**
       * 隐藏modal
       */
      hideModal: function hideModal() {
        this.$modal.hide('msg');
        this.$modal.hide('information');
        this.$modal.hide('linkModal');
        this.$modal.hide('dialog');
        this.consumHideEvent();
      },

      /**
       * 关闭modal
       */
      closedModal: function closedModal() {
        this.hideModal();
      },
      getCookie: function getCookie(cookieName) {
        var arrCookie = document.cookie.split(";");
        for (var i = 0; i < arrCookie.length; i++) {
          var arr = item.split("=");
          if (cookieName === arr[0]) {
            return arr[1];
          }
        }
        return "";
      },
      setToken: function setToken() {
        this.token = this.getCookie('X-Set-Token');
        if (token) {
          appStorage.set('token', token);
          appStorage.set('customer', { token: token });
        }
      }
    }
  };
});
